import {
	ChangeDetectionStrategy,
	ChangeDetectorRef,
	Component,
	EventEmitter,
	forwardRef,
	Input,
	OnInit,
	Output
} from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Required } from '@app-shared/decorators/required.decorator';
import { OptionButtonItem } from '../option-button-group/option-button-group.component';

@Component({
	selector: 'app-bed-bath-select',
	templateUrl: './bed-bath-select.component.html',
	styleUrls: ['./bed-bath-select.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: forwardRef(() => BedBathSelectComponent),
			multi: true
		}
	]
})
export class BedBathSelectComponent implements ControlValueAccessor, OnInit {
	@Required() @Input() type: 'bedrooms' | 'bathrooms';
	@Input() isColorVariant?: boolean = false;
	@Input() label?: string;
	@Input() appearance: 'fill' | 'outline' | 'standard' | 'legacy' = 'legacy';
	@Input()
	set customValues(values: number[] | null | undefined) {
		this._customValues = Array.isArray(values) ? [...values] : undefined;
		this.buildOptions();
	}

	@Output() valueSelected = new EventEmitter<number | null>();

	value: number | null = null;
	private _customValues?: number[];

	private onChange: (v: number | null) => void = () => {};
	private onTouched: () => void = () => {};

	options: OptionButtonItem<number>[] = [];

	constructor(private readonly cdr: ChangeDetectorRef) {}

	ngOnInit(): void {
		this.buildOptions();
	}

	private buildOptions(): void {
		const baseValues =
			this._customValues != null
				? this._customValues
				: this.type === 'bedrooms'
				? [1, 2, 3, 4, 5]
				: [1, 1.5, 2, 3, 3.5];

		this.options = baseValues.map(n => ({ label: `${n}+`, value: n }));
	}

	writeValue(obj: number | null): void {
		this.value = obj ?? null;
		this.cdr.markForCheck();
	}
	registerOnChange(fn: (value: number | null) => void): void {
		this.onChange = fn;
	}
	registerOnTouched(fn: () => void): void {
		this.onTouched = fn;
	}
	disabled = false;
	setDisabledState?(isDisabled: boolean): void {
		this.disabled = Boolean(isDisabled);
		this.cdr.markForCheck();
	}

	onSelect(v: number | null): void {
		this.value = v;
		this.onChange(v);
		this.onTouched();
		this.valueSelected.emit(v);
		this.cdr.markForCheck();
	}

	get resolvedLabelKey(): string {
		return this.type === 'bedrooms' ? 'searchProperties.filters.minBedrooms' : 'searchProperties.filters.minBathrooms';
	}
}
